<script setup lang="ts">
  import { computed } from 'vue';
  import type { IconBackgroundProps } from './IconBackground.types';
  import { iconBackgroundBaseClass } from './IconBackground.css';

  const props = defineProps<IconBackgroundProps>();

  const sizeStyleObj = computed(() => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
    backgroundColor: props.color,
  }));
</script>

<template>
  <div :class="iconBackgroundBaseClass" :style="sizeStyleObj">
    <slot></slot>
  </div>
</template>
